import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { OverledenIcon } from "../icons/OverledenIcon";
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {
    disabled?: boolean;
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const MarkeerAlsOverledenButton = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('client');
    return (<Button startIcon={<OverledenIcon />} disabled={props.disabled} onClick={e => {e.stopPropagation(); props.onClick && props.onClick()}} variant="contained" color="secondary">{t('markAsDeceased')}</Button>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));

